module.exports = __webpack_public_path__ + "static/media/welcometitle.b9739ab7.png";